export enum PaymentMethodType {
  boleto = 1,
  creditCard = 2,
  pix = 3,
}